import http from '../../../services/api'

const apiPath = import.meta.env.VITE_API_PATH

function baseUnitPath(itemUuid: string): string {
  return `${apiPath}items/${itemUuid}/uom-change`
}

/** Call backend to validate/preview a potential base-unit change. */
async function validateBaseUnitChange(itemUuid: string, newUnitUuid: string): Promise<any> {
  return await http.post(baseUnitPath(itemUuid) + '/validate', {
    new_base_unit_uuid: newUnitUuid,
  })
}

/** Call backend to preview conversion/reconciliation details. */
async function previewBaseUnitConversion(
  itemUuid: string,
  newUnitUuid: string,
  conversionFactor?: number,
): Promise<any> {
  const payload: any = { new_base_unit_uuid: newUnitUuid }
  if (conversionFactor !== undefined) payload.conversion_factor = conversionFactor
  return await http.post(baseUnitPath(itemUuid) + '/preview', payload)
}

/** Submit the confirmed conversion/reconciliation request. */
async function confirmBaseUnitConversion(
  itemUuid: string,
  newUnitUuid: string,
  conversionFactor?: number,
  stockFingerprint?: string,
  confirmValue?: boolean,
): Promise<any> {
  const payload: any = {
    new_base_unit_uuid: newUnitUuid,
    confirm: confirmValue !== undefined ? confirmValue : true,
  }
  if (conversionFactor !== undefined) payload.conversion_factor = conversionFactor
  if (stockFingerprint !== undefined) payload.stock_fingerprint = stockFingerprint
  return await http.post(baseUnitPath(itemUuid) + '/confirm', payload, {
    errorHandle: false,
  } as any)
}

const baseUnitService = {
  validateBaseUnitChange,
  previewBaseUnitConversion,
  confirmBaseUnitConversion,
}

export default baseUnitService
